export function trimProtocol(url: string) {
  return url.replace(/^https?:\/\//, '');
}
